import './utils/prototypes'
import { createRoot } from 'react-dom/client'
import { QueryClient, QueryClientProvider } from 'react-query'
import 'styles/tailwind.css'
import 'styles/customChartTooltip.css'
import 'styles/animations.scss'
import 'styles/Root.scss'
import { ReactQueryDevtools } from 'react-query/devtools'
import { createPortal } from 'react-dom'
import { SettingsProvider } from 'core/hooks/useSettings'
import { defaultSettings, isProd } from 'app/settings/defaultSetting'
import { GoogleOAuthProvider } from '@react-oauth/google'
import { LoadScript } from '@react-google-maps/api'
import ErrorBoundary from 'app/ErrorBoundary'
import { ConfigProvider } from 'antd'
import enUSLatest from 'antd/locale/en_US'
import { BrowserRouter, RouterProvider } from 'react-router-dom'
import { appRoutes } from 'routes/appRoutes'
import AppLoadingIndicator from 'core/components/loaders/AppLoadingIndicator'
import React from 'react'
import AntdTheme from 'styles/AntdTheme'

export const queryClient = new QueryClient()

const App = () => {
  return (
    <>
      {window.location.hostname === 'localhost' &&
        isProd &&
        createPortal(
          <div className="absolute z-[10000] top-[5px] left-1/2 -translate-x-1/2 p-1 bg-danger-1 border border-danger-3 rounded-md text-xs text-danger-4 select-none">
            Using <strong>PRODUCTION API</strong> on <strong>local</strong>!
          </div>,
          document.body
        )}
      <QueryClientProvider client={queryClient}>
        <SettingsProvider value={defaultSettings}>
          <GoogleOAuthProvider
            clientId={process.env.REACT_APP_GOOGLE_CLIENT_ID ?? ''}
          >
            <ConfigProvider locale={enUSLatest} theme={AntdTheme}>
              <LoadScript
                libraries={['geometry']}
                googleMapsApiKey={process.env.REACT_APP_GOOGLE_MAPS_KEY ?? ''}
              >
                <ErrorBoundary>
                  <RouterProvider
                    router={appRoutes}
                    fallbackElement={<AppLoadingIndicator />}
                  />
                  <BrowserRouter>
                    <ReactQueryDevtools
                      initialIsOpen={false}
                      position="bottom-right"
                    />
                  </BrowserRouter>
                </ErrorBoundary>
              </LoadScript>
            </ConfigProvider>
          </GoogleOAuthProvider>
        </SettingsProvider>
      </QueryClientProvider>
    </>
  )
}

const container = document.getElementById('root')
// eslint-disable-next-line @typescript-eslint/no-non-null-assertion
const root = createRoot(container!)
root.render(<App />)

queryClient.setQueryDefaults(['users', 'me'], {
  staleTime: 10000,
  retry: 3
})
queryClient.setQueryDefaults(['roles'], {
  staleTime: Infinity,
  retry: 3
})

queryClient.setQueryDefaults(['programs'], {
  staleTime: Infinity
})
